import * as React from 'react';
import { Link } from 'gatsby';
import classNames from 'classnames';
import { createStyles, Theme, WithStyles, withStyles } from '@material-ui/core/styles';
import Divider from '@material-ui/core/Divider';
import Drawer, { DrawerProps } from '@material-ui/core/Drawer';
import Grid from '@material-ui/core/Grid';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import HomeIcon from '@material-ui/icons/Home';
import { Functions } from '@material-ui/icons';
import { PaperProps } from '@material-ui/core';

const categories = [
  {
    id: 'Equations',
    children: [
      { id: 'Battery Runtime', icon: <Functions />, page: 'BatteryRuntimePage' },
      { id: 'Ohms Law', icon: <Functions />, page: 'OhmsLawPage' },
      { id: 'Resistor Divider', icon: <Functions />, page: 'ResistorDividerPage' },
      { id: 'Tank Circuit', icon: <Functions />, page: 'TankCircuitPage' },
      { id: 'Wavelength', icon: <Functions />, page: 'WavelengthPage' },
    ],
  },
];

const styles = (theme: Theme) =>
  createStyles({
    categoryHeader: {
      paddingTop: 16,
      paddingBottom: 16,
    },
    categoryHeaderPrimary: {
      color: theme.palette.common.white,
    },
    item: {
      paddingTop: 4,
      paddingBottom: 4,
      color: 'rgba(255, 255, 255, 0.7)',
    },
    itemCategory: {
      backgroundColor: '#232f3e',
      boxShadow: '0 -1px 0 #404854 inset',
      paddingTop: 16,
      paddingBottom: 16,
    },
    firebase: {
      fontSize: 24,
      fontFamily: theme.typography.fontFamily,
      color: theme.palette.common.white,
    },
    itemActionable: {
      '&:hover': {
        backgroundColor: 'rgba(255, 255, 255, 0.08)',
      },
    },
    itemActiveItem: {
      color: '#4fc3f7',
    },
    itemPrimary: {
      color: 'inherit',
      fontSize: theme.typography.fontSize,
      '&$textDense': {
        fontSize: theme.typography.fontSize,
      },
    },
    textDense: {},
    divider: {
      marginTop: theme.spacing(2),
    },
  });

interface NavigatorProps extends WithStyles<typeof styles> {
  location?: Location;
  PaperProps?: Partial<PaperProps>;
  variant?: DrawerProps['variant'];
  open?: boolean;
  onClose?: () => void;
}

function Navigator(props: NavigatorProps): JSX.Element {
  const { classes, location = null, PaperProps = {}, variant = 'permanent', open, onClose } = props;
  const matchPath = location ? location.pathname.replace(/\//g, '') : null;
  return (
    <Drawer PaperProps={PaperProps} variant={variant} open={open} onClose={onClose}>
      <List disablePadding>
        <ListItem className={classNames(classes.firebase, classes.item, classes.itemCategory)}>
          <Grid container alignItems="center" direction="row">
            <Grid item>EEE</Grid>
          </Grid>
        </ListItem>

        <Link style={{ textDecoration: 'none', color: 'inherit' }} to="/">
          <ListItem className={classNames(classes.item, classes.itemCategory)}>
            <ListItemIcon>
              <HomeIcon />
            </ListItemIcon>
            <ListItemText
              classes={{
                primary: classes.itemPrimary,
              }}
            >
              About
            </ListItemText>
          </ListItem>
        </Link>
        {categories.map(({ id, children }) => (
          <React.Fragment key={id}>
            <ListItem className={classes.categoryHeader}>
              <ListItemText
                classes={{
                  primary: classes.categoryHeaderPrimary,
                }}
              >
                {id}
              </ListItemText>
            </ListItem>
            {children.map(({ id: childId, icon, page = null }) => {
              return page ? (
                <Link
                  key={childId}
                  style={{ textDecoration: 'none', color: 'inherit' }}
                  to={`/${page}/index.html`}
                >
                  <ListItem
                    button
                    dense
                    className={classNames(
                      classes.item,
                      classes.itemActionable,
                      (matchPath && page ? matchPath === page : false) && classes.itemActiveItem,
                    )}
                  >
                    <ListItemIcon>{icon}</ListItemIcon>
                    <ListItemText className={classNames(classes.itemPrimary, classes.textDense)}>
                      {childId}
                    </ListItemText>
                  </ListItem>
                </Link>
              ) : (
                <div />
              );
            })}
            <Divider className={classes.divider} />
          </React.Fragment>
        ))}
      </List>
    </Drawer>
  );
}

export default withStyles(styles)(Navigator);
